<script>
import { debounce } from 'lodash';

export default {
  name: 'InputQuantite',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxQuantite: {
      type: Number,
      required: true
    },
    minQuantite: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    inner_value: null,
    touched: false
  }),
  watch: {
    value (value) {
      this.inner_value = value;
    },
    inner_value: debounce(function (value) {
      if (value === '' || value === null || value === undefined || isNaN(value)) {
        this.inner_value = null;
      } else {
        if (typeof value === 'string') {
          this.inner_value = parseFloat(value.replace(',', '.'));
        }

        if (value < 0 || isNaN(value)) {
          this.inner_value = 0;
        }
      }

      // eslint-disable-next-line eqeqeq
      if (this.value != this.inner_value) {
        this.updateValue();
      }
    }, 50)
  },
  created () {
    this.inner_value = this.value;
  },
  methods: {
    updateValue () {
      this.$emit('input', this.inner_value);
    },
    onBlur () {
      this.touched = true;
    },
    onTouch () {
      this.touched = true;
    },
    incrementQuantite () {
      if (this.inner_value === null || this.inner_value === undefined) {
        this.inner_value = this.minQuantite;
      } else {
        let value = ((this.inner_value * 1000) + (this.step * 1000)) / 1000; // fix floating point errors

        if (value > this.maxQuantite) {
          value = this.maxQuantite;
        }
        if (value < this.minQuantite) {
          value = this.minQuantite;
        }

        this.inner_value = value;
      }
    },
    decrementQuantite () {
      if (this.inner_value === null || this.inner_value === undefined) {
        this.inner_value = this.minQuantite;
      } else {
        let value = ((this.inner_value * 1000) - (this.step * 1000)) / 1000; // fix floating point errors

        if (value > this.maxQuantite) {
          value = this.maxQuantite;
        }
        if (value < this.minQuantite) {
          value = this.minQuantite;
        }
        this.inner_value = value;
      }
    }
  }
};
</script>

<template>
  <div class="quantite-cnt">
    <v-card class="white py-2 px-4 mr-1">
      <NumberField
        v-model="inner_value"
        type="number"
        lang="en"
        label="Quantité *"
        validate-on-blur
        :rules="rules"
        :disabled="disabled"
        hide-details
        :step="step"
        @blur="onBlur()"
        @change="onTouch()"
      >
        <template v-slot:prepend>
          <v-icon
            class="currentColor"
            @click="decrementQuantite()"
          >
            mdi-minus-circle
          </v-icon>
        </template>
        <template v-slot:append-outer>
          <v-icon
            class="currentColor"
            @click="incrementQuantite()"
          >
            mdi-plus-circle
          </v-icon>
        </template>
      </NumberField>
    </v-card>
    <v-input
      class="unite"
      :rules="rules"
      hide-details
    >
      tonnes
      <CardsHelp
        :page="'QUANTITE'"
        :niveau="'SOUS-TITRE'"
      />
    </v-input>

    <v-input
      v-if="touched && rules && rules.length"
      error
      :messages="rules"
      style="width:100%"
    />
  </div>
</template>

<style lang="scss" scoped>
.quantite-cnt {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  & .v-text-field::v-deep input {
    width: 5em;
  }
}

.unite,
.unite * {
  display: inline !important;
}
</style>
